import styled, { css } from 'styled-components';
import { TagContentStyledProps, TagIntent, TagStyledProps } from './Tag.typed';

const getIntentStyles = (intent: TagIntent) => {
  switch (intent) {
    case 'dark':
      return css`
        background: rgba(0, 0, 0, 0.48);
        color: #ffffff;
      `;
    case 'success':
      return css`
        background: #3eba40;
        color: #ffffff;
        font-weight: bolder;
      `;
    default:
      return css`
        background: #f2f2f2;
        color: #666;
      `;
  }
};

export const Tag = styled.button<TagStyledProps>`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  margin-bottom: ${({ theme }) => theme.spacing.S2};
  min-width: 24px;
  height: 24px;
  overflow: hidden;
  text-align: center;
  border-radius: ${({ theme }) => theme.borderRadius.s};
  box-shadow: ${({ theme, elevated }) =>
    elevated ? theme.shadow.primary : 'none'};
  ${({ intent }) => getIntentStyles(intent)}

  ${({ clickable }) =>
    clickable &&
    css`
      // Creates a larger touch target when clickable
      &:before {
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        min-height: 40px;
        min-width: 40px;
        content: '';
        transform: translate(-50%, -50%);
      }
    `}
`;
export const Leading = styled.span`
  display: inline-flex;
`;
export const Trailing = styled.span`
  display: inline-flex;
`;
export const Content = styled.span<TagContentStyledProps>`
  flex: none;
  font-size: ${({ theme }) => theme.typography.fontSizes.S12};
  font-weight: ${({ theme, weight }) => theme.typography.fontWeights[weight]};
  line-height: ${({ theme }) => theme.typography.lineHeights.S16};
`;
